import { render, staticRenderFns } from "./AccountCreate.vue?vue&type=template&id=0badab8b&"
import script from "./AccountCreate.vue?vue&type=script&lang=js&"
export * from "./AccountCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports